import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { UcontrolAuthService } from '../services/ucontrol-auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class UcontrolAuthInterceptor implements HttpInterceptor {
  constructor(private authService: UcontrolAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isUcontrolRequest = req.url.includes(environment.ucontrol.apiUrl);

    if (!isUcontrolRequest) {
      return next.handle(req);
    }

    return this.authService.getToken().pipe(
      switchMap((token) => {
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });

        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              console.warn('⚠️ UControl Bridge token rejected (401), invalidating and retrying...');
              this.authService.invalidateToken();

              return this.authService.getToken().pipe(
                switchMap((newToken) => {
                  const retryReq = req.clone({
                    setHeaders: {
                      Authorization: `Bearer ${newToken}`
                    }
                  });
                  return next.handle(retryReq);
                })
              );
            }

            return throwError(() => error);
          })
        );
      }),
      catchError((error) => {
        console.error('❌ UcontrolAuthInterceptor error:', error);
        return throwError(() => error);
      })
    );
  }
}
